module.exports = __webpack_public_path__ + "img/Dantam Hair 58.11bb8fbc.jpg";